/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { getWireTransferInformation, uploadFile, discardFile } from 'state/actions/accountState/account_data';
// component
import WireTransfer from 'pages/dashboard/account/paymentinfo/selectmethod/wiretransfer/wiretransfer';



/* ========== ~~~~~~~~~~ WIRE TRANSFER : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ accountData, sessionStatus }) => ({
    fields: accountData.WIRE.fields,
    hasStoredData: !!Object.keys(accountData.WIRE.storedData).length,
    selectedPaymentType: accountData.selectedPaymentType,
    paymentUUID: accountData.paymentUUID,
    editable: accountData.WIRE.editable,
    storedData: accountData.WIRE.storedData,
    accountUUID: sessionStatus.accountUUID
});

// map actions
const mapDispatchToProps = dispatch => ({
    getWireTransferInformation: (hasStoredData, formName, accountUUID) => dispatch(getWireTransferInformation(hasStoredData, formName, accountUUID)),
    uploadFile: ( file, formName ) => dispatch(uploadFile( file, formName )),
    discardFile: (formName) => dispatch(discardFile(formName))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(WireTransfer);
